import { Star, Quotes, GoogleLogo } from "@phosphor-icons/react";
import { Reveal, SectionHead } from "./Reveal";
import { TESTIMONIALS } from "@/data/content";
import { useLanguage } from "@/i18n";

const Stars = () => (
  <div className="flex gap-1" data-testid="testimonial-stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={16} weight="fill" className="text-gold-bright" />
    ))}
  </div>
);

export default function Testimonials() {
  const { lang, t } = useLanguage();
  return (
    <section id="reviews" data-testid="testimonials-section" className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-36">
      <SectionHead index={t.reviews.index} overline={t.reviews.overline} title={t.reviews.title} align="center" testid="reviews" />
      <Reveal delay={0.15} className="mt-8 flex justify-center">
        <div data-testid="google-reviews-badge" className="flex items-center gap-3 border border-gold/25 bg-surface px-5 py-2.5">
          <GoogleLogo size={20} weight="bold" className="text-gold" />
          <span className="text-xs uppercase tracking-[0.25em] text-[#A3A3A3]">
            {t.reviews.googleLeft} <span className="text-gold">5.0</span> {t.reviews.googleRight}
          </span>
        </div>
      </Reveal>
      <div className="mt-16 grid gap-8 md:grid-cols-2">
        {TESTIMONIALS.map((tm, i) => (
          <Reveal key={tm.name.en} delay={(i % 2) * 0.12}>
            <blockquote
              data-testid={`testimonial-card-${i}`}
              className="group relative h-full border border-gold/15 bg-surface p-8 transition-all duration-500 hover:-translate-y-2 hover:border-gold/50 hover:shadow-lg hover:shadow-gold/5 md:p-10"
            >
              <Quotes size={36} weight="fill" className="absolute right-8 top-8 text-gold/15 transition-colors duration-500 group-hover:text-gold/30 rtl:left-8 rtl:right-auto" />
              <Stars />
              <p className="mt-6 font-serif text-lg italic leading-relaxed text-[#E5C07B] md:text-xl">“{tm.quote[lang]}”</p>
              <footer className="mt-8 border-t border-gold/10 pt-5">
                <p className="text-sm uppercase tracking-[0.2em] text-[#FAFAFA]">{tm.name[lang]}</p>
                <p className="mt-1 text-xs tracking-wider text-[#A3A3A3]">{tm.role[lang]}</p>
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
